import React from 'react';

const StartUpScreen = () => {
    return (
        <>
            <div className="img_container">
                <div className="img_wrapper">
                    <img
                        className="login_img"
                        src="/assets/images/login/login.png" // Correct path for React (no need for import)
                        alt="Login"
                        width={1000}
                        height={1000}
                    />
                </div>

                {/* <div className="credit_wrapper">
                    <h6>
                        Designed & Developed by -{' '}
                        <a
                            href="https://rsinfotechsys.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Right Serve Infotech System Pvt. Ltd.
                        </a>
                    </h6>
                </div> */}
            </div>
        </>
    );
};

export default StartUpScreen;
